var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskHandler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4,0H1.6C0.7,0,0,0.7,0,1.6v12.8C0,15.3,0.7,16,1.6,16h0.7h11.4h0.7c0.9,0,1.6-0.7,1.6-1.6V1.6 C16,0.7,15.3,0,14.4,0z M2.8,15c0.3-2.5,2.6-4.4,5.2-4.4s4.8,2,5.2,4.4H2.8z M7.5,9.3c-1-0.2-1.9-1-2.1-2.1C5.2,6.3,5.5,5.4,6.1,4.8 C6.6,4.3,7.3,4,8,4c0.2,0,0.3,0,0.5,0c1,0.2,1.9,1,2.1,2.1c0.2,0.9-0.1,1.8-0.7,2.4C9.2,9.2,8.4,9.4,7.5,9.3z M15,14.4 c0,0.3-0.3,0.6-0.6,0.6h-0.3c-0.3-2.4-2.1-4.5-4.4-5.2c0.3-0.2,0.6-0.4,0.9-0.6c0.8-0.8,1.2-2.1,1-3.3c-0.3-1.4-1.4-2.6-2.8-2.8 c-1.2-0.2-2.4,0.1-3.3,1C4.6,5,4.2,6.2,4.4,7.4c0.2,1.1,0.9,2,1.8,2.5C4,10.6,2.1,12.6,1.9,15H1.6C1.2,15,1,14.8,1,14.4V1.6 C1,1.2,1.2,1,1.6,1h12.8C14.8,1,15,1.2,15,1.6V14.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskHandler);
export default __webpack_public_path__ + "static/media/task-handler.9af4c00cc3edcd945e6ab8b864bc9320.svg";
export { ForwardRef as ReactComponent };